import { render, staticRenderFns } from "./ordList.vue?vue&type=template&id=3ca59d33&scoped=true&"
import script from "./ordList.vue?vue&type=script&lang=js&"
export * from "./ordList.vue?vue&type=script&lang=js&"
import style0 from "./ordList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ordList.vue?vue&type=style&index=1&id=3ca59d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca59d33",
  null
  
)

export default component.exports